

export class PrestacaoEntidade {
  public CD_FUNDACAO: string;
  public ANO_CONTRATO: number;
  public NUM_CONTRATO: number;
  public SEQ_PREST: number;
  public TIPO: string;
  public PARCELA?: number;
  public DT_VENC?: Date;
  public DT_PAGTO?: Date;
  public CD_ORIGEM_REC?: number;
  public VL_PRINCIPAL?: number;
  public VL_JUROS?: number;
  public VL_PRESTACAO?: number;
  public VL_MULTA?: number;
  public VL_MORA?: number;
  public VL_MULTA_SALDO?: number;
  public VL_MORA_SALDO?: number;
  public VL_DESCONTO?: number;
  public VL_RECEBIDO?: number;
  public VL_SALDO_ANT?: number;
  public VL_SALDO_ATUAL?: number;
  public VL_TX_ADM?: number;
  public VL_TX_SEGURO?: number;
  public VL_TX_INAD?: number;
  public VL_IOF?: number;
  public VL_CORR_SALDO?: number;
  public VL_CORR_PRINC?: number;
  public VL_CORR_JUROS?: number;
  public VL_INDICE?: number;
  public VL_INDICE_ACUM?: number;
  public VL_CORR_PREST_ATRASO?: number;
  public VL_ACRESCIMO?: number;
  public ENVIO_COBRANCA?: number;
  public DT_ENVIO_COBRANCA?: Date;
  public ORIGEM_LANC: string;
  public VL_CORR_PREST?: number;
  public VL_CORR_PREST_ACUM?: number;
  public VL_MORA_ACUM?: number;
  public VL_TX_INVALIDEZ?: number;
  public TX_JUROS_ACUM?: number;
  public NOVO_PRAZO?: number;
  public VL_DESC_SEGURO?: number;
  public VL_DESC_SEGURO_ESPECIAL?: number;
  public VL_JUROS_CONTRATO?: number;
  public VL_PAGTO_PARCIAL?: number;
  public ID_MORATORIA: string;
  public VL_IOF_COMPLEMENTAR?: number;
  public TX_NOVO_JUROS?: number;
  public BLOQUEIO_COBRANCA: string;
  public VL_SALDO_MEDIO?: number;
  public DT_ENVIO_NOT_COBRANCA?: Date;
  public NUM_NOT_COBRANCA_ENVIADA?: number;
  public DES_VL_RECEBIDO: string;
}